// START IMPORTS
import { Box } from '@ltvco/refresh-lib/theme';
// END IMPORTS

/**
 * One “Label: value” span pair for the metadata row (bold label, regular value).
 */
export function metadataRowSegment(label: string, value: string) {
  return (
    <Box component="span">
      <Box component="span" sx={{ fontWeight: 600 }}>
        {label}
      </Box>
      {': '}
      <Box component="span" sx={{ fontWeight: 400 }}>
        {value}
      </Box>
    </Box>
  );
}
